import { createContext, useContext } from "react";

export type FloatingFieldSize = "sm" | "md";

export interface FloatingFieldContextValue {
  size: FloatingFieldSize;
  hasValue: boolean;
  setHasValue: (v: boolean) => void;
  name: string;
  /**
   * Controls the label suffix rendered by FloatingField.Label:
   *   - undefined (default) — no suffix; treat as required
   *   - true               — no suffix; explicitly required
   *   - false              — renders "(optional)" suffix
   *
   * Must be passed explicitly as `required={false}` to show the optional indicator.
   */
  required?: boolean;
}

export const FloatingFieldContext = createContext<FloatingFieldContextValue | null>(null);

export function useFloatingField(): FloatingFieldContextValue {
  const ctx = useContext(FloatingFieldContext);
  if (!ctx) throw new Error("FloatingField sub-components must be used inside <FloatingField>");
  return ctx;
}
